export const ROLE_MASTER_ACCOUNT = 'ROLE_MASTER';
export const ROLE_SALES_REP = 'ROLE_SALES_REP';

export const isEmpty = (value: string): boolean => {
	return (!value || value.length === 0);
};

/**
 * Method to verify if a user has a certain client role.
 *
 * @private
 * @param {string} role
 * @param {string} rolesArray
 * @return {boolean}
 */
const _userHasRole = (role: string, rolesArray: string): boolean => {
	const userRoles = rolesArray;
	if (isEmpty(userRoles)) {
		return false;
	}

	const rolesAsArray = userRoles.split(',');
	return rolesAsArray.includes(role);
};

/**
 * Shorthand method to check if the user has the given client role
 * @param role
 */
export const hasClientRole = (role: string): boolean => _userHasRole(role, window.userClientRoles);

/**
 * Method to quickly verify if a user has the master account role
 */
export const hasRoleMasterAccount = (): boolean => hasClientRole(ROLE_MASTER_ACCOUNT);

/**
 * Method to quickly verify if a user has the master account role
 */
export const hasRoleSalesRep = (): boolean => hasClientRole(ROLE_SALES_REP);

/**
 * Method to quickly verify if a user has the master account role or the sales rep role
 */
export const hasRoleMasterOrSalesRep = (): boolean => hasRoleMasterAccount() || hasRoleSalesRep();
